export default __webpack_public_path__ + "static/media/delete.abcee35c.svg";